<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="项目管理" name="first">
				<div class="k-page-common">
					<div class="k-common-header">
						<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
							<el-form :inline="true" :model="searchForm" size="mini">
								<el-form-item label="客户简称">
									<el-input v-model="searchForm.customer_as" placeholder="请填写客户简称" clearable></el-input>
								</el-form-item>
								<el-form-item label="项目名称">
									<el-input v-model="searchForm.project_name" placeholder="请填写项目名称" clearable></el-input>
								</el-form-item>
								<el-form-item label="项目编号">
									<el-input v-model="searchForm.project_code" placeholder="请填写项目编号" clearable></el-input>
								</el-form-item>
								<el-form-item label="商务">
									<el-select v-model="searchForm.business_docking_id" filterable remote
										:remote-method="(query) => getUserSelect(query, 'shangwu')" placeholder="请选择商务" clearable>
										<el-option v-for="item in options.business_docking_id_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="媒介执行">
									<el-select v-model="searchForm.edit_medium_id" filterable remote
										:remote-method="(query) => getUserSelect(query, 'meijie')" placeholder="请选择媒介执行" clearable>
										<el-option v-for="item in options.edit_medium_id_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="客户执行">
									<el-select v-model="searchForm.uid" filterable remote
										:remote-method="(query) => getUserSelect(query, 'kehu')" placeholder="请选择客户" clearable>
										<el-option v-for="item in options.uid_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="项目所属部门">
									<el-cascader v-model="searchForm.dept_id" :options="options.dept_id_options"
										:props="{ checkStrictly: true, label: 'department_name', value: 'id' }" clearable></el-cascader>
								</el-form-item>
								<el-form-item label="项目状态">
									<el-select v-model="searchForm.status" placeholder="请选择" style="width: 100%;" clearable>
										<el-option v-for="item in options.status_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="创建日期">
									<el-date-picker clearable align="center" v-model="searchForm.create_time" type="daterange"
										value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
										end-placeholder="结束日期"></el-date-picker>
								</el-form-item>
								<el-form-item label="发布日期">
									<el-date-picker clearable align="center" v-model="searchForm.expected_release_date" type="daterange"
										value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
										end-placeholder="结束日期"></el-date-picker>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" @click="doSearch">查询</el-button>
									<el-button type="primary" @click="reset">重置</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="k-table-toolbar" style="margin-top:0;"
								v-if="$parent.$parent.isAuthAction('admin/customers/customer/createproject') || $parent.$parent.isAuthAction('admin/customers/customer/acceptproject') || $parent.$parent.isAuthAction('admin/customers/customer/editmedium') || $parent.$parent.isAuthAction('admin/customers/customer/solveprojectorun') || $parent.$parent.isAuthAction('admin/customers/customer/solveprojectorun') || $parent.$parent.isAuthAction('admin/customers/customer/submitcustomerrefund') || $parent.$parent.isAuthAction('admin/customers/export/exportprojectexcel')">
								<div>
									<el-button type="primary" size="mini" @click="addProjectOpen"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/createproject')">新建项目</el-button>
									<el-button size="mini" @click="acceptProject" :disabled="multipleSelection.length == 0"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/acceptproject')">接受任务</el-button>
									<el-button size="mini" @click="editMediumOpen" :disabled="multipleSelection.length == 0"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/editmedium')">变更媒介执行</el-button>
									<el-button size="mini" @click="editExecuteOpen" :disabled="multipleSelection.length == 0"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/editCustomerAbutment')">变更客户执行</el-button>
									<el-button size="mini" @click="closeCase(1)" :disabled="multipleSelection.length == 0"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/solveprojectorun')">结案</el-button>
									<el-button size="mini" @click="closeCase(2)" :disabled="multipleSelection.length == 0"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/solveprojectorun')">反结案</el-button>
									<el-button size="mini" @click="openTurn()" :disabled="multipleSelection.length == 0"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/submitcustomerrefund')">退款申请</el-button>
								</div>
								<div style="margin-right: 10px;">
									<el-link type="primary" :disabled="isDownloading" icon="el-icon-download" @click="exportData"
										v-if="$parent.$parent.isAuthAction('admin/customers/export/exportprojectexcel')">{{ isDownloading ?
											'下载中...' : '下载' }}</el-link>
								</div>
							</div>
							<div class="k-table-con radio">
								<el-table :data="tableData.data" style="width: 100%" border stripe ref="table" highlight-current-row
									v-loading="loading" @sort-change="sortChange"  
									@row-click="onSelectOp">
									<!-- @select-all="onSelectAll" -->
									 <!-- @selection-change="selectItem" -->
									<!-- <el-table-column type="selection" align="center" width="55">
									</el-table-column> -->

									<el-table-column fixed prop="project_name" label="项目名称" min-width="150">
										<template slot-scope="scope">
											<el-link type="primary" style="font-size: 12px; text-decoration: underline;" :underline="false"
												@click.stop="detail(scope.row)" target="_blank">{{ scope.row.project_name }}</el-link>
										</template>
									</el-table-column>
									<el-table-column fixed prop="project_code" label="项目编码" min-width="170">
									</el-table-column>
									<el-table-column prop="customer_name" label="所属客户" min-width="250">
									</el-table-column>
									<el-table-column prop="customer_as" label="客户简称" min-width="180">
									</el-table-column>
									<el-table-column prop="project_resource_num" label="执行数量" min-width="100">
									</el-table-column>
									<!-- <el-table-column
									prop="project_budget_revenue_yssr"
									label="项目预算收入"
									min-width="100">
							</el-table-column>
							<el-table-column
									prop="project_budget_cost_yscb"
									label="项目预算成本"
									min-width="100">
							</el-table-column>
							<el-table-column
									prop="project_budget_profit_margin"
									label="预算利润"
									min-width="100">
							</el-table-column> -->
									<el-table-column prop="amountCost" label="客户报价" min-width="100">
									</el-table-column>
									<el-table-column prop="amount_pay_Cost" label="支出金额" min-width="100">
									</el-table-column>
									<el-table-column prop="chengben_pay_Cost" label="报价成本" min-width="100">
									</el-table-column>
									<el-table-column prop="li_run" label="商务利润" min-width="100">
									</el-table-column>
									<el-table-column prop="li_run_lv" label="商务利润率" min-width="100">
									</el-table-column>
									<el-table-column prop="point_pay_Cost" label="单次返点(总计)" min-width="120">
									</el-table-column>
									<el-table-column prop="dc_fandian_ys" label="单次返点（已收)" min-width="120">
									</el-table-column>
									<el-table-column prop="dc_fandian_sy_ys" label="单次返点（应收)" min-width="120">
									</el-table-column>
									<el-table-column prop="yi_kaipiao_customer_cost" label="已开票（客户）" min-width="120">
									</el-table-column>
									<el-table-column prop="fandian_kaipiao_fandian_cost" label="已开票（返点）" min-width="120">
									</el-table-column>
									<el-table-column prop="yfk_cost" label="已付款金额" min-width="120">
									</el-table-column>
									<el-table-column prop="zxmx_tk" label="执行明细退款" min-width="120">
									</el-table-column>
									<el-table-column prop="amount_pay_Cost" label="实际支出金额" min-width="120">
									</el-table-column>
									<el-table-column prop="yf_cost" label="应付金额" min-width="120">
									</el-table-column>
									<el-table-column prop="ysp_cost" label="已收票金额" min-width="120">
									</el-table-column>
									<el-table-column prop="wsp_cost" label="未收票金额" min-width="120">
									</el-table-column>
									<el-table-column prop="yi_sk_cost" label="已收款金额" min-width="100">
									</el-table-column>
									<el-table-column prop="ying_sk_cost" label="应收金额" min-width="100">
									</el-table-column>
									<el-table-column prop="business_txt" label="商务" width="80">
									</el-table-column>
									<!-- <el-table-column
									prop="old_medium_txt"
									label="原媒介执行"
									width="100">
							</el-table-column> -->
									<el-table-column prop="old_edit_medium_txt" label="媒介执行" width="100">
									</el-table-column>
									<el-table-column prop="uid_txt" label="客户执行" width="80">
									</el-table-column>
									<el-table-column prop="uid_depart" label="项目所属部门" width="100">
									</el-table-column>
									<el-table-column prop="expected_release_date" label="预计发布日期" min-width="120">
									</el-table-column>
									<el-table-column prop="expected_receipt_date_start" label="预计首款日期" min-width="100">
									</el-table-column>
									<el-table-column prop="expected_receipt_date_end" label="预计尾款日期" min-width="100">
									</el-table-column>
									<el-table-column prop="expected_receipt_date_start_sj" label="实际首款日期" min-width="100">
									</el-table-column>
									<el-table-column prop="expected_receipt_date_end_sj" label="实际尾款日期" min-width="100">
									</el-table-column>
									<el-table-column prop="isContact" label="项目合同" min-width="80">
									</el-table-column>
									<el-table-column prop="payment_status" label="收款状态" min-width="100">
									</el-table-column>
									<!-- :filters="[{ text: '部分收款', value: '部分收款' }, { text: '未收款', value: '未收款' }, { text: '已收款', value: '已收款' }, { text: '收款异常', value: '收款异常' }]" -->
									<!-- :filter-method="filterPaystatus" -->
									<el-table-column prop="create_time" label="创建时间" width="160" sortable="custom">
									</el-table-column>
									<el-table-column prop="update_time" label="修改时间" width="160" sortable="custom">
									</el-table-column>
									<el-table-column align="center" prop="jiean_status" label="结案审核状态" width="110">
										<template slot-scope="scope">
											<span style="font-weight: bold;">{{ scope.row.jiean_status }}</span>
										</template>
									</el-table-column>
									<el-table-column fixed="right" align="center" prop="status_txt" label="状态" width="80">
									</el-table-column>
									<el-table-column fixed="right" label="操作"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/canelproject') || $parent.$parent.isAuthAction('admin/customers/customer/delprojects') || $parent.$parent.isAuthAction('admin/customers/customer/editproject') || $parent.$parent.isAuthAction('admin/customers/customer/submitprojectapproval') || $parent.$parent.isAuthAction('admin/customers/customer/relationresource') || $parent.$parent.isAuthAction('admin/customers/customer/submitproresource') || $parent.$parent.isAuthAction('admin/customers/customer/executequotation') || $parent.$parent.isAuthAction('admin/customers/customer/editprojectname')"
										min-width="220">
										<template slot-scope="scope" v-if="scope.row.status!=13">
											<!-- and scope.row.edit_medium_id == '' -->
											<el-button @click.stop="handleTableDelete(scope.row)" type="text" :size="size"
												:disabled="!([2, 4, 8, 9, 10, 11].indexOf(scope.row.status) == -1)"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/delprojects')">删除</el-button>
											<el-button @click.stop="handleTableEditOpen(scope.row)" type="text" :size="size"
												:disabled="!([2, 8, 9, 10, 11].indexOf(scope.row.status) == -1)"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/editproject')">编辑</el-button>
											<el-button @click.stop="handleTableFlow(scope.row)" type="text" :size="size"
												:disabled="!([1, 3].indexOf(scope.row.status) != -1)"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/submitprojectapproval')">提交审批</el-button>
											<el-button @click.stop="handleTableResourceOpen(scope.row)" type="text" :size="size"
												:disabled="!([1, 3, 4, 6, 7].indexOf(scope.row.status) != -1)"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/relationresource')">匹配资源</el-button>
											<el-button @click.stop="handleTableProResourceOpen(scope.row, 'pipei')" type="text" :size="size"
												:disabled="!([1, 3, 4, 6, 7].indexOf(scope.row.status) != -1)"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/submitproresource')">匹配补充</el-button>
											<el-button ref="buchongButton" @click.stop="handleTableProResourceOpen(scope.row, 'baojia')"
												type="text" :size="size" :disabled="!([1, 3, 4, 6, 7].indexOf(scope.row.status) != -1)"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/executequotation')">报价</el-button>
											<el-button @click.stop="editProjectName(scope.row,scope.$index)" type="text" :size="size"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/editprojectname')">变更名称</el-button>
											<el-button @click.stop="canelproject(scope.row,scope.$index)" type="text" :size="size"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/canelproject')">作废</el-button>
										</template>
									</el-table-column>
								</el-table>
								<el-pagination background ref="pagination" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="tableData.page | number"
									:page-sizes="[15, 30, 50, 100]" :page-size="tableData.pagesize | number"
									layout="prev, pager, next, sizes, total" :total="tableData.total | number">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--新建项目-->
		<el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" :wrapperClosable="false"
			:close-on-press-escape="false" direction="rtl" size="70%">
			<el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="140px"
				v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>新建项目</span>
						<i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content">
					<el-form-item label="项目类型" prop="project_type">
						<el-select v-model="addForm.project_type" placeholder="请选择" style="width: 100%;" clearable>
							<el-option v-for="item in options.project_type_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="客户" prop="customer_id">
						<el-select v-model="addForm.customer_id" filterable remote placeholder="请选择" style="width: 100%;" clearable
							:remote-method="getCustomer">
							<el-option v-for="item in options.customer_id_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="媒介所属部门">
						<el-cascader @change="handleChangeDepartment" placeholder="请选择部门" style="width: 100%;"
							v-model="medium_department_id" :options="options.usertree_options"
							:props="{ multiple: false, emitPath: false, value: 'id', label: 'department_name', checkStrictly: 'true' }"
							:show-all-levels="false" filterable clearable></el-cascader>
					</el-form-item>
					<el-form-item label="媒介执行" prop="medium_id">
						<el-select v-model="addForm.medium_id" placeholder="请选择媒介执行">
							<el-option v-for="item in options.users_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否预收款" prop="is_payment">
						<el-radio-group v-model="addForm.is_payment">
							<el-radio label="YES">是</el-radio>
							<el-radio label="NO">否</el-radio>
						</el-radio-group>
						<div style="margin-top:5px" v-if="addForm.is_payment == 'YES'">
							<el-input v-model="addForm.payment_ratio" placeholder="请填写预收款比例" clearable>
								<template slot="append">%</template>
							</el-input>
						</div>
					</el-form-item>
					<el-form-item label="项目名称" prop="project_name">
						<el-input v-model="addForm.project_name" placeholder="请填写项目名称; 例:客户简称-XX年XX月-具体项目名称" clearable maxlength="100"
							show-word-limit></el-input>
						<span style="color: red;">注意命名规则:客户简称-XX年XX月-具体项目名称</span>
					</el-form-item>
					<!-- <el-form-item label="项目预算收入" prop="project_budget_revenue">
				  <el-input v-model="addForm.project_budget_revenue" placeholder="请填写项目预算收入" clearable></el-input>
				</el-form-item>
				<el-form-item label="项目预算成本" prop="project_budget_cost">
				  <el-input v-model="addForm.project_budget_cost" placeholder="请填写项目预算成本" clearable></el-input>
				</el-form-item>
				<el-form-item label="预算利润率">
					{{addFormlv}}
				</el-form-item> -->
					<el-form-item label="预计发布日期" prop="expected_release_date">
						<el-date-picker v-model="addForm.expected_release_date" type="date" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" clearable placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="预计首款收款日期" prop="expected_receipt_date_start">
						<el-date-picker v-model="addForm.expected_receipt_date_start" type="date" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" clearable placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="预计尾款收款日期" prop="expected_receipt_date_end">
						<el-date-picker v-model="addForm.expected_receipt_date_end" type="date" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" clearable placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="需求说明" prop="project_need">
						<el-input type="textarea" v-model="addForm.project_need" placeholder="请填写需求说明" clearable maxlength="220"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="需求附件">
						<el-upload action multiple accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xlsx,.xlx,.ppt,.pptx,.eml,.bmp"
							:file-list="addForm.project_need_imgs"
							:on-remove="(file) => handleRemoveUpload(file, 'addForm', 'project_need_imgs', false)"
							:auto-upload="false" :on-change="(file) => changeRequired(file, 'addForm', 'project_need_imgs', false)"
							:on-preview="viewImg">
							<el-button slot="trigger" size="mini">选取文件</el-button>
							<span style="margin-left: 10px; cursor: pointer;">
								<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf/doc/docx/xlsx/xlx/ppt/pptx/eml/bmp格式"
									placement="bottom-start">
									<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
								</el-tooltip>
							</span>
						</el-upload>
					</el-form-item>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="addProject" :size='size'>提交</el-button>
					<el-button :size='size' @click="addFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
		<!--编辑项目-->
		<el-drawer custom-class="k-drawer" :visible.sync="editFormVisiable" :wrapperClosable="false"
			:close-on-press-escape="false" direction="rtl" size="70%">
			<el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="140px"
				v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>编辑项目</span>
						<i class="el-icon-close k-drawer-close" @click="editFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content">
					<el-form-item label="项目类型" prop="project_type">
						<el-select v-model="editForm.project_type" placeholder="请选择" style="width: 100%;" clearable>
							<el-option v-for="item in options.project_type_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="客户" prop="customer_id">
						<el-select v-model="editForm.customer_id" filterable remote placeholder="请选择" style="width: 100%;" clearable
							:remote-method="getCustomer" v-if="editForm.status != 4">
							<el-option v-for="item in options.customer_id_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-input v-model="editForm.customer_name" disabled clearable v-else>
						</el-input>
					</el-form-item>
					<!-- <el-form-item label="媒介" prop="medium_id">
				  <el-cascader
				  	placeholder="请选择媒介" style="width: 100%;"
				  	v-model="editForm.medium_id"
				    :options="options.usertree_options"
				    :props="{ multiple: false, emitPath:false }"
				  	:show-all-levels="false"
					:disabled="editForm.status!=5"
				  	filterable
				    clearable></el-cascader>
                </el-form-item> -->
					<el-form-item label="是否预收款" prop="is_payment">
						<el-radio-group v-model="editForm.is_payment">
							<el-radio label="YES">是</el-radio>
							<el-radio label="NO">否</el-radio>
						</el-radio-group>
						<div style="margin-top:5px" v-if="editForm.is_payment == 'YES'">
							<el-input v-model="editForm.payment_ratio" placeholder="请填写预收款比例" clearable>
								<template slot="append">%</template>
							</el-input>
						</div>
					</el-form-item>
					<el-form-item label="项目名称" prop="project_name">
						<el-input v-model="editForm.project_name" placeholder="请填写项目名称" clearable maxlength="100"
							show-word-limit></el-input>
							<span style="color: red;">注意命名规则:客户简称-XX年XX月-具体项目名称</span>
					</el-form-item>
					<!-- <el-form-item label="项目预算收入" prop="project_budget_revenue">
                  <el-input v-model="editForm.project_budget_revenue" placeholder="请填写项目预算收入" clearable></el-input>
                </el-form-item>
                <el-form-item label="项目预算成本" prop="project_budget_cost">
                  <el-input v-model="editForm.project_budget_cost" placeholder="请填写项目预算成本" clearable></el-input>
                </el-form-item>
				<el-form-item label="预算利润率">
					{{editFormlv}}
				</el-form-item> -->
					<el-form-item label="预计发布日期" prop="expected_release_date">
						<el-date-picker v-model="editForm.expected_release_date" type="date" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" clearable placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="预计首款收款日期" prop="expected_receipt_date_start">
						<el-date-picker v-model="editForm.expected_receipt_date_start" type="date" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" clearable placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="预计尾款收款日期" prop="expected_receipt_date_end">
						<el-date-picker v-model="editForm.expected_receipt_date_end" type="date" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" clearable placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="需求说明" prop="project_need">
						<el-input type="textarea" v-model="editForm.project_need" placeholder="请填写需求说明" clearable maxlength="220"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="需求附件">
						<el-upload action multiple accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xlsx,.xlx,.ppt,.pptx,.eml,.bmp"
							:file-list="editForm.project_need_imgs"
							:on-remove="(file) => handleRemoveUpload(file, 'editForm', 'project_need_imgs', false)"
							:auto-upload="false" :on-change="(file) => changeRequired(file, 'editForm', 'project_need_imgs', false)"
							:on-preview="viewImg">
							<el-button slot="trigger" size="mini">选取文件</el-button>
							<span style="margin-left: 10px; cursor: pointer;">
								<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf/doc/docx/xlsx/xlx/ppt/pptx/eml/bmp格式"
									placement="bottom-start">
									<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
								</el-tooltip>
							</span>
						</el-upload>
					</el-form-item>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="editProject" :size='size'>提交</el-button>
					<el-button :size='size' @click="editFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
		<!--重新分配媒介-->
		<el-dialog title="重新分配媒介" v-loading="loading" :close-on-click-modal="false" :visible.sync="editMediumFormVisiable"
			width="40%">
			<el-form :model="editMediumForm" ref="editMediumForm" :size="size" :rules="rules.editMediumForm"
				label-width="110px">
				<div>
					<el-form-item label="媒介所属部门">
						<el-cascader @change="handleChangeDepartment" placeholder="请选择部门" style="width: 100%;"
							v-model="medium_department_id" :options="options.usertree_options"
							:props="{ multiple: false, emitPath: false, value: 'id', label: 'department_name', checkStrictly: 'true' }"
							:show-all-levels="false" filterable clearable></el-cascader>
					</el-form-item>
					<el-form-item label="媒介执行" prop="medium_id">
						<el-select v-model="editMediumForm.medium_id" placeholder="请选择媒介执行">
							<el-option v-for="item in options.users_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="媒介">
					<el-cascader
						placeholder="请选择媒介" style="width: 100%;"
						v-model="editMediumForm.medium_id"
					    :options="options.usertree_options"
					    :props="{ multiple: false, emitPath:false }"
						:show-all-levels="false"
						filterable
					    clearable></el-cascader>
				  </el-form-item> -->
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="editMedium" :size='size'>提交</el-button>
				<el-button :size='size' @click="editMediumFormVisiable = false">取消</el-button>
			</span>
		</el-dialog>
		<!--重新分配执行-->
		<el-dialog title="重新分配执行" v-loading="loading" :close-on-click-modal="false" :visible.sync="editExecuteFormVisiable"
			width="40%">
			<el-form :model="editExecuteForm" ref="editExecuteForm" :size="size" :rules="rules.editExecuteForm"
				label-width="110px">
				<div>
					<el-form-item label="执行所属部门">
						<el-cascader @change="handleChangeDepartment" placeholder="请选择部门" style="width: 100%;"
							v-model="editExecuteForm.uid_department_id" :options="options.usertree_options"
							:props="{ multiple: false, emitPath: false, value: 'id', label: 'department_name', checkStrictly: 'true' }"
							:show-all-levels="false" filterable clearable></el-cascader>
					</el-form-item>
					<el-form-item label="客户执行" prop="uid">
						<el-select v-model="editExecuteForm.uid" placeholder="请选择客户执行">
							<el-option v-for="item in options.users_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="editExecute" :size='size'>提交</el-button>
				<el-button :size='size' @click="editExecuteFormVisiable = false">取消</el-button>
			</span>
		</el-dialog>
		<!--匹配补充-->
		<el-drawer custom-class="k-drawer" v-loading="loading" :wrapperClosable="false" :close-on-press-escape="false"
			:visible.sync="editProResourcelistVisiable" direction="rtl" size="95%">
			<div class="drawer-header">
				<div class="header-title">
					<span>{{ editProResourcelistVisiableTitle }}</span>
					<i class="el-icon-close k-drawer-close" @click="editProResourcelistVisiable = false"></i>
				</div>
			</div>
			<div class="drawer-content">
				<div class="" style="max-height:calc(100vh - 100px); overflow: auto; height: auto !important;">
					<div class="" style="margin: 0; flex:none; display: block;">
						<el-table :data="proResourceData" style="width: 100%;" :height="tableHeight2" border stripe
							v-loading="loading" ref="tablepro" :row-class-name="tableRowClassName" highlight-current-row>
							<el-table-column fixed prop="execute_code" label="执行编码" align="center" min-width="250">
							</el-table-column>
							<el-table-column fixed prop="platform_id_txt" label="所属平台" min-width="80">
							</el-table-column>
							<el-table-column fixed prop="resource_id_txt" label="资源名称" min-width="150">
							</el-table-column>
							<el-table-column prop="release_method_txt" label="发布方式" min-width="150">
							</el-table-column>
							<el-table-column prop="is_platform_order_txt" label="是否平台下单">
							</el-table-column>
							<el-table-column prop="is_point_txt" label="是否返点">
							</el-table-column>
							<!--  <el-table-column
										prop="kan_price"
										min-width="220"
										label="刊例价">
										<template slot-scope="scope">
											<p v-for="(item,index) in scope.row.kan_price" :key="index">{{item}}</p>
										</template>
								</el-table-column> -->
							<el-table-column prop="li_run" label="商务利润(元)" width="220">
							</el-table-column>
							<el-table-column prop="li_run_lv" label="商务利润率" width="100">
							</el-table-column>
							<el-table-column prop="point_price" label="返点金额(元)" width="110">
							</el-table-column>
							<el-table-column prop="chengbeng_price" label="成本价格(元)" min-width="150">
							</el-table-column>
							<el-table-column prop="quotation_price" label="报价(元)" width="100">
							</el-table-column>
							<el-table-column prop="strike_price" label="执行价(元)" width="100">
							</el-table-column>
							<el-table-column prop="invoice_type_txt" label="发票类型" min-width="100">
							</el-table-column>
							<el-table-column label="执行价对比" width="100">
								<template slot-scope="scope">
									<el-popover placement="right" width="330" v-if="scope.row.dd_quotation_price_arr.length > 0"
										trigger="hover">
										<div class="ressupplier">
											<div class="_row">
												<div class="str">原执行价</div>
												<div class="dashed"></div>
												<div class="price">{{ scope.row.dd_strike_price_arr[0] }}</div>
											</div>
											<div class="_row">
												<div class="str">现执行价</div>
												<div class="dashed"></div>
												<div class="price">{{ scope.row.dd_strike_price_arr[1] }}</div>
											</div>
										</div>
										<p :style="{ color: isColor(scope.row.dd_strike_price), 'font-weight': 'bold' }" slot="reference">
											{{ isUp(scope.row.dd_strike_price) }}</p>
									</el-popover>
									<p v-else :style="{ color: isColor(scope.row.dd_strike_price), 'font-weight': 'bold' }"
										slot="reference">
										{{ isUp(scope.row.dd_strike_price) }}</p>
								</template>
							</el-table-column>
							<!-- <el-table-column
									label="报价对比"
									width="100">
									<template slot-scope="scope">
										<el-popover
										  placement="right"
										  width="330"
										  v-if="scope.row.dd_quotation_price_arr.length > 0"
										  trigger="hover">
										    <div class="ressupplier">
												<div class="_row">
													<div class="str">原报价</div>
													<div class="dashed"></div>
													<div class="price">{{scope.row.dd_quotation_price_arr[0]}}</div>
												</div>
												<div class="_row">
													<div class="str">现报价</div>
													<div class="dashed"></div>
													<div class="price">{{scope.row.dd_quotation_price_arr[1]}}</div>
												</div>
											</div>
										    <p :style="{color:isColor(scope.row.dd_quotation_price),'font-weight':'bold'}" slot="reference">{{isUp(scope.row.dd_quotation_price)}}</p>
										</el-popover>
										<p v-else :style="{color:isColor(scope.row.dd_quotation_price),'font-weight':'bold'}">{{isUp(scope.row.dd_quotation_price)}}</p>
									</template>
								</el-table-column> -->
							<el-table-column prop="dd_lirun" label="利润对比" width="100">
								<template slot-scope="scope">
									<el-popover placement="right" width="330" v-if="scope.row.dd_lirun_arr.length > 0" trigger="hover">
										<div class="ressupplier">
											<div class="_row">
												<div class="str">原利润</div>
												<div class="dashed"></div>
												<div class="price">{{ scope.row.dd_lirun_arr[0] }}</div>
											</div>
											<div class="_row">
												<div class="str">现利润</div>
												<div class="dashed"></div>
												<div class="price">{{ scope.row.dd_lirun_arr[1] }}</div>
											</div>
										</div>
										<p :style="{ color: isColor(scope.row.dd_lirun), 'font-weight': 'bold' }" slot="reference">
											{{ isUp(scope.row.dd_lirun) }}</p>
									</el-popover>
									<p v-else :style="{ color: isColor(scope.row.dd_lirun), 'font-weight': 'bold' }">
										{{ isUp(scope.row.dd_lirun) }}</p>
								</template>
							</el-table-column>
							<el-table-column prop="dd_lirun_lv" label="利润率对比" width="100">
								<template slot-scope="scope">
									<el-popover placement="right" width="330" v-if="scope.row.dd_lirun_lv_arr.length > 0" trigger="hover">
										<div class="ressupplier">
											<div class="_row">
												<div class="str">原利润率</div>
												<div class="dashed"></div>
												<div class="price">{{ scope.row.dd_lirun_lv_arr[0] }}</div>
											</div>
											<div class="_row">
												<div class="str">现利润率</div>
												<div class="dashed"></div>
												<div class="price">{{ scope.row.dd_lirun_lv_arr[1] }}</div>
											</div>
										</div>
										<p :style="{ color: isColor(scope.row.dd_lirun_lv), 'font-weight': 'bold' }" slot="reference">
											{{ isUp(scope.row.dd_lirun_lv) }}</p>
									</el-popover>
									<p v-else :style="{ color: isColor(scope.row.dd_lirun_lv), 'font-weight': 'bold' }">
										{{ isUp(scope.row.dd_lirun_lv) }}</p>
								</template>
							</el-table-column>
							<el-table-column prop="release_time" label="发布日期" width="120">
							</el-table-column>
							<el-table-column prop="create_time" label="创建时间" width="160">
							</el-table-column>
							<el-table-column fixed="right" prop="status_txt" label="状态" width="80"
								:filters="[{ text: '待提交', value: '1' }, { text: '待审核', value: '2' }, { text: '被驳回', value: '3' }, { text: '正常', value: '4' }, { text: '匹配中', value: '5' }, { text: '已发布', value: '6' }, { text: '供应商对账', value: '7' }, { text: '已作废', value: '8' }, { text: '撤销中', value: '9' }, { text: '待报价', value: '10' }]"
								:filter-method="filterStatus">
							</el-table-column>
							<el-table-column fixed="right" label="操作" width="160">
								<template slot-scope="scope">
									<el-button @click.stop="proResourceDetailOpen(scope.row)" type="text" :size="size"
										v-if="checkStatusVisible && scope.row.status != 2 && scope.row.status != 7 && scope.row.status != 8 && isCheckList && $parent.$parent.isAuthAction('admin/customers/customer/submitproresource')">补充</el-button>
									<el-button @click.stop="copyProResource(scope.row)" type="text" :size="size"
										v-if="checkStatusVisible && scope.row.status != 2 && scope.row.status != 8 && isCheckList && $parent.$parent.isAuthAction('admin/customers/customer/submitproresource')">复制</el-button>
									<el-button @click.stop="delProresource(scope.row)" type="text" :size="size"
										v-if="checkStatusVisible && [2, 4, 6, 7, 8, 9].indexOf(scope.row.status) == -1 && isCheckList && $parent.$parent.isAuthAction('admin/customers/customer/delproresource')">删除</el-button>
									<el-button @click.stop="executeQuotationOpen(scope.row)" type="text" :size="size"
										v-if="!checkStatusVisible && [1, 3, 4, 6, 7, 8, 10].indexOf(scope.row.status) != -1 && $parent.$parent.isAuthAction('admin/customers/customer/executequotation') && [8, 9, 10].indexOf(scope.row.project_status) == -1">报价</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
			<div class="drawer-footer">
				<el-button type="primary" @click="submitproresource" :disabled="checkStatus" v-if="checkStatusVisible"
					:size='size'>提交匹配</el-button>
				<el-button :size='size' @click="editProResourcelistVisiable = false">关闭</el-button>
			</div>
		</el-drawer>
		<!--补充-->
		<el-drawer custom-class="k-drawer" :visible.sync="editProResourceFormVisiable" direction="rtl"
			:wrapperClosable="false" :close-on-press-escape="false" size="70%">
			<el-form :model="editProResourceForm" ref="editProResourceForm" :size="size" :rules="rules.editProResourceForm"
				label-width="140px" v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>补充</span>
						<i class="el-icon-close k-drawer-close" @click="editProResourceFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content" v-loading="loading">
					<el-form-item label="资源名称" class="resource_name">
						<img :src="editProResourceForm.attachment" alt="">
						<span>{{ editProResourceForm.resource_id_txt }}</span>
					</el-form-item>
					<el-form-item label="供应商" prop="supplier_id">
						<el-select v-if="editProResourceForm.platform_id == 9" v-model="editProResourceForm.supplier_id" filterable
							placeholder="请选择" style="width: 100%;" clearable @change="changSupplier()">
							<el-option v-for="item in options.supplier_id_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-input v-else v-model="supplier_name" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="发布方式" prop="release_method">
						<el-select @change="viewJianYiPrice" v-model="editProResourceForm.release_method" filterable
							placeholder="请选择" style="width: 100%;" clearable>
							<el-option v-for="item in options.release_method_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否平台下单" prop="is_platform_order">
						<el-radio-group v-model="editProResourceForm.is_platform_order" @input="changeBank">
							<el-radio label="YES">是</el-radio>
							<el-radio label="NO">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="是否小红星" v-if="editProResourceForm.platform_id==4 && editProResourceForm.is_platform_order=='YES'">
						<el-radio-group v-model="editProResourceForm.is_xiaohongxing" @input="changexiaohx">
							<el-radio label="YES">是 (加收2%服务费)</el-radio>
							<el-radio label="NO">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="收款银行" prop="receiving_bank">
						<el-select v-model="editProResourceForm.receiving_bank" filterable placeholder="请选择" style="width: 100%;"
							clearable @change="changeInvoice">
							<el-option v-for="item in options.receiving_bank_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="发票信息" prop="invoice_type">
						<el-select v-model="editProResourceForm.invoice_type" filterable placeholder="请选择" style="width: 100%;"
							clearable>
							<el-option v-for="item in options.invoice_type_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<template
						v-if="editProResourceForm.supplier_id && editProResourceForm.release_method && editProResourceForm.receiving_bank && editProResourceForm.invoice_type">
						<el-form-item>
							<p style="color:red">
								参考价:平台执行价{{ janyi_p_price.toFixed(2) }}元【刊例价-折扣+平台服务费】,非平台执行价{{ janyi_f_price.toFixed(2)
								}}元【刊例价-折扣】,资源执行价{{ janyi_z_price.toFixed(2) }}元【刊例价-折扣】,合作价{{ janyi_h_price.toFixed(2) }}元【刊例价-折扣】
							</p>
						</el-form-item>
						<el-form-item label="执行价" prop="strike_price">
							<el-input v-model="editProResourceForm.strike_price" placeholder="请填写执行价" clearable
								@blur="bypricetonum()"></el-input>
						</el-form-item>
						<el-form-item label="支出金额">
							<el-input v-model="editProResourceForm.zhichu_price" disabled placeholder="请填写支出金额" clearable></el-input>
						</el-form-item>
						<el-form-item label="是否有返点" prop="is_point">
							<el-radio-group v-model="editProResourceForm.is_point" @input="changePoint">
								<el-radio label="YES">是</el-radio>
								<el-radio label="NO">否</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item v-if="editProResourceForm.is_point == 'YES'">
							<p style="color:red">
								参考价:【折后刊例价*折扣比例】平台返点{{ janyi_point_p_price.toFixed(2) }}元,非平台返点{{ janyi_point_f_price.toFixed(2)
								}}元,资源返点{{ janyi_point_z_price.toFixed(2) }}元,合作返点:{{ janyi_point_h_price.toFixed(2) }}元
							</p>
						</el-form-item>
						<el-form-item label="媒体返点金额" prop="point_price" v-if="editProResourceForm.is_point == 'YES'">
							<el-input v-model="editProResourceForm.point_price" placeholder="请填写媒体返点金额" clearable
								@blur="bypricetonum()"></el-input>
						</el-form-item>
						<el-form-item label="报价成本">
							<el-input v-model="editProResourceForm.baojia_chengbeng_price" disabled placeholder="请填写报价成本"
								clearable></el-input>
						</el-form-item>
						<el-form-item label="客户报价" prop='quotation_price' v-if="!editProResourceFormVisiable">
							<el-input v-model="editProResourceForm.quotation_price" placeholder="请填写客户报价" clearable
								@blur="bypricetonum()"></el-input>
						</el-form-item>
						<!-- <el-form-item label="媒体暗点金额" v-if="editProResourceForm.is_point == 'YES' && $parent.$parent.isAuthAction('admin/customers/customer/andian')">
					  <el-input v-model="editProResourceForm.black_point_price" placeholder="请填写媒体暗点金额" clearable></el-input>
					</el-form-item> -->
						<el-form-item label="商务利润" v-if="!editProResourceFormVisiable">
							<el-input v-model="editProResourceForm.li_run" disabled placeholder="请填写商务利润" clearable></el-input>
						</el-form-item>
						<el-form-item label="商务利润率" v-if="!editProResourceFormVisiable">
							<el-input v-model="editProResourceForm.li_run_lv" disabled placeholder="请填写商务利润率" clearable>
								<template slot="append">%</template>
							</el-input>
						</el-form-item>
					</template>
					<el-form-item label="预付款日期">
						<el-date-picker v-model="editProResourceForm.pay_time" type="date" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" clearable placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="预计发布日期" prop="release_time">
						<el-date-picker v-model="editProResourceForm.release_time" type="date" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" clearable placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="推荐理由" key="recommend_message">
						<el-input type="textarea" v-model="editProResourceForm.recommend_message" placeholder="请输入推荐理由" clearable
							maxlength="100" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="备注" key="remark">
						<el-input v-model="editProResourceForm.remark" placeholder="请输入备注" clearable maxlength="100"
							show-word-limit></el-input>
					</el-form-item>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="editProResource()" :size='size'>提交</el-button>
					<el-button :size='size' @click="editProResourceFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
		<!--报价-->
		<el-drawer custom-class="k-drawer" :visible.sync="executeQuotationFormVisiable" direction="rtl"
			:wrapperClosable="false" :close-on-press-escape="false" size="70%">
			<el-form :model="editProResourceForm" ref="editProResourceForm" :size="size" :rules="rules.editProResourceForm"
				label-width="140px" v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>报价</span>
						<i class="el-icon-close k-drawer-close" @click="executeQuotationFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content" v-loading="loading">
					<el-form-item label="资源名称" class="resource_name">
						<img :src="editProResourceForm.attachment" alt="">
						<span>{{ editProResourceForm.resource_id_txt }}</span>
					</el-form-item>
					<el-form-item label="供应商">
						<span>{{ editProResourceForm.supplier_id_txt }}</span>
					</el-form-item>
					<el-form-item label="发布方式">
						<span>{{ editProResourceForm.release_method_txt }}</span>
					</el-form-item>
					<el-form-item label="是否平台下单">
						<span>{{ editProResourceForm.is_platform_order_txt }}</span>
					</el-form-item>
					<el-form-item label="报价成本">
						<span>{{ editProResourceForm.baojia_chengbeng_price }}</span>
					</el-form-item>
					<el-form-item label="客户报价" prop='quotation_price'>
						<el-input v-model="editProResourceForm.quotation_price" placeholder="请填写客户报价" clearable
							@blur="bypricetonum('baojia')"></el-input>
					</el-form-item>
					<el-form-item label="商务利润">
						<el-input v-model="editProResourceForm.li_run" disabled placeholder="请填写商务利润" clearable></el-input>
					</el-form-item>
					<el-form-item label="商务利润率">
						<el-input v-model="editProResourceForm.li_run_lv" disabled placeholder="请填写商务利润率" clearable>
							<template slot="append">%</template>
						</el-input>
					</el-form-item>
					<el-form-item label="预计发布日期" prop="release_time">
						<el-date-picker v-model="editProResourceForm.release_time" type="date" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" clearable placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="executeQuotation()" :size='size'>提交</el-button>
					<el-button :size='size' @click="executeQuotationFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
		<!--申请退款-->
		<el-drawer custom-class="k-drawer" :visible.sync="turnFormVisiable" direction="rtl" :wrapperClosable="false"
			:close-on-press-escape="false" size="70%">
			<el-form :model="turnForm" ref="turnForm" :size="size" :rules="rules.turnForm" label-width="140px"
				v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>退款申请</span>
						<i class="el-icon-close k-drawer-close" @click="turnFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content">
					<el-form-item label="退款账户" prop="refund_bank_id">
						<el-select v-model="turnForm.refund_bank_id" filterable remote placeholder="请选择退款账户" clearable
							style="width: 100%;">
							<el-option v-for="item in options.refund_bank_id_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="收款账户" prop="collect_bank_id">
						<el-select v-model="turnForm.collect_bank_id" filterable remote placeholder="请选择收款账户" clearable
							style="width: 100%;">
							<el-option v-for="item in options.collect_bank_id_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="退款金额" prop="refund_price">
						<div style="display: flex;">
							<div style="width: 220px; margin-right: 10px;">
								<el-input v-model="turnForm.refund_price" placeholder="请填写退款金额" clearable></el-input>
							</div>
							<span style="color: #F56C6C;">(可退款金额：{{ turnData.use_refund_price }})</span>
						</div>
					</el-form-item>
					<el-form-item label="退款日期" prop="refund_date">
						<el-date-picker v-model="turnForm.refund_date" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
							placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="退款凭证" prop="prove_attachment">
						<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="turnForm.prove_attachment"
							:on-remove="(file) => handleRemoveUpload(file, 'turnForm', 'prove_attachment', true)" :auto-upload="false"
							:on-change="(file) => changeRequired(file, 'turnForm', 'prove_attachment', true)" :on-preview="viewImg">
							<el-button slot="trigger" size="mini">选取文件</el-button>
							<span style="margin-left: 10px; cursor: pointer;">
								<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
									<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
								</el-tooltip>
							</span>
						</el-upload>
					</el-form-item>
					<el-form-item label="退款原因" prop="refund_reason">
						<el-input type="textarea" v-model="turnForm.refund_reason" placeholder="请填写退款原因" clearable maxlength="100"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="申请备注">
						<el-input type="textarea" v-model="turnForm.remark" placeholder="请填写申请备注" clearable maxlength="100"
							show-word-limit></el-input>
					</el-form-item>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="addTurn" :size='size'>提交</el-button>
					<el-button :size='size' @click="turnFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
		<el-dialog :visible.sync="dialogVisibleImg">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>
<script>
export default {
	data () {
		return {
			isDownloading: false,
			supplier_name: '',
			janyi_point_p_price: 0,
			janyi_point_f_price: 0,
			janyi_point_z_price: 0,
			janyi_point_h_price: 0,
			janyi_p_price: 0,
			janyi_f_price: 0,
			janyi_z_price: 0,
			janyi_h_price: 0,
			medium_department_id: '',
			dialogImageUrl: '',
			dialogVisibleImg: false,
			addFormVisiable: false,
			editFormVisiable: false,
			editMediumFormVisiable: false,
			editProResourceFormVisiable: false,//补充详情弹窗
			editProResourcelistVisiable: false,//匹配补充弹窗
			executeQuotationFormVisiable: false,//报价
			editProResourcelistVisiableTitle: '',//匹配补充and报价弹窗的标题
			editExecuteFormVisiable: false,
			turnFormVisiable: false,
			activeName: 'first',
			size: 'mini',
			loading: true,
			pipeibucho: '',
			pickerOptions: {
				disabledDate (time) {
					// 获取今天的日期
					const today = new Date();
					today.setHours(0, 0, 0, 0); // 设置时间为00:00:00:000
					return time.getTime() < today.getTime(); // 禁用今天之前的日期
				}
			},
			options: {
				users_options: [],
				edit_medium_id_options: [],
				business_docking_id_options: [],
				uid_options: [],
				dept_id_options: [],
				project_type_options: [
					{
						value: 1,
						label: '常规项目'
					}, {
						value: 2,
						label: '代下单'
					}, {
						value: 3,
						label: '星图代开户'
					}, {
						value: 4,
						label: '星图优选'
					}, {
						value: 5,
						label: '特殊执行'
					}, {
						value: 6,
						label: '代付款'
					}, {
						value: 7,
						label: '关联公司项目'
					}, {
						value: 8,
						label: '供应商对抵下单'
					}
				],
				is_blacklist_options: [
					{
						value: 1,
						label: '是'
					}, {
						value: 2,
						label: '否'
					}
				],
				status_options: [
					{
						value: 1,
						label: '待提交'
					}, {
						value: 2,
						label: '待审核'
					}, {
						value: 3,
						label: '被驳回'
					}, {
						value: 4,
						label: '正常'
					}, {
						value: 5,
						label: '待领取'
					}, {
						value: 6,
						label: '待匹配'
					}, {
						value: 7,
						label: '匹配中'
					}, {
						value: 8,
						label: '结案中'
					}, {
						value: 9,
						label: '已结案'
					}, {
						value: 10,
						label: '反结案中'
					}, {
						value: 11,
						label: '变更中'
					}, {
						value: 13,
						label: '已作废'
					}
				],
				customer_id_options: [],//客户
				usertree_options: [],//所有用户
				supplier_id_options: [],//供应商
				release_method_options: [],//发布方式
				receiving_bank_options: [],//收款银行
				invoice_type_options: [],//发票信息
				refund_bank_id_options: [],
				collect_bank_id_options: [],
			},
			supplier_active: 0,
			searchForm: {
				customer_as: '',
				project_name: '',
				project_code: '',
				expected_release_date: '',
				create_time: '',
				status: '',
				edit_medium_id: '',
				business_docking_id: '',
				uid: '',
				dept_id: ''
			},
			resetSearch: {
				customer_as: '',
				project_name: '',
				project_code: '',
				expected_release_date: '',
				create_time: '',
				status: '',
				edit_medium_id: '',
				business_docking_id: '',
				uid: '',
				dept_id: ''
			},
			addForm: {
				project_type: "",
				customer_id: "",
				medium_id: '',
				is_payment: "NO",
				payment_ratio: '',
				project_name: "",
				project_budget_revenue: "",
				project_budget_cost: "",
				expected_release_date: "",
				expected_receipt_date_start: "",
				expected_receipt_date_end: "",
				project_need: "",
				project_need_imgs: []
			},
			addFormlv: '0.00%',
			editFormlv: '0.00%',
			editForm: {
				project_type: "",
				customer_id: "",
				medium_id: '',
				is_payment: "NO",
				payment_ratio: '',
				project_name: "",
				project_budget_revenue: "",
				project_budget_cost: "",
				expected_release_date: "",
				expected_receipt_date_start: "",
				expected_receipt_date_end: "",
				project_need: "",
				project_need_imgs: [],
				status: '',
				lv: ''
			},
			editMediumForm: {
				project_code: '',
				medium_id: ''
			},
			editExecuteForm: {
				uid_department_id: '',
				uid: ''
			},
			editProResourceForm: {
				execute_code: '',
				attachment: '',
				resource_id_txt: '',
				supplier_id: '',
				release_method: '',
				is_platform_order: '',
				is_xiaohongxing: '',
				receiving_bank: '',
				invoice_type: '',
				strike_price: '',
				zhichu_price: '',
				baojia_chengbeng_price: '',
				quotation_price: '',
				is_point: '',
				point_price: '',
				black_point_price: '',
				li_run: '',
				li_run_lv: '',
				pay_time: '',
				release_time: ''
			},
			turnForm: {
				project_ids: '',
				refund_bank_id: '',
				collect_bank_id: '',
				prove_attachment: [],
				refund_date: '',
				refund_price: '',
				refund_reason: '',
				remark: ''
			},
			rules: {
				addForm: {
					'project_type': [
						{ required: true, message: '请选择项目类型', trigger: ['change', 'blur'] }
					],
					'customer_id': [
						{ required: true, message: '请选择客户', trigger: ['change', 'blur'] }
					],
					'medium_id': [
						{ required: true, message: '请选择媒介', trigger: ['change', 'blur'] }
					],
					'is_payment': [
						{ required: true, message: '请选择是否预收款', trigger: ['change', 'blur'] },
						{
							validator: (rule, value, callback) => {
								if ((this.addForm.is_payment == 'YES' && !this.addForm.payment_ratio) || !value) {
									callback(new Error('请填写预收款比例'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'payment_ratio': [
						{ required: true, message: '请填写预收款比例', trigger: ['change', 'blur'] }
					],
					'project_name': [
						{ required: true, message: '请填写项目名称', trigger: ['change', 'blur'] }
					],
					'project_budget_revenue': [
						{ required: true, message: '请填写项目预算收入', trigger: ['change', 'blur'] },
						{ validator: this.validateNumber, trigger: 'blur' }
					],
					'project_budget_cost': [
						{ required: true, message: '请填写项目预算成本', trigger: ['change', 'blur'] },
						{ validator: this.validateNumber, trigger: 'blur' }
					],
					'expected_release_date': [
						{ required: true, message: '请选择预计发布日期', trigger: ['change', 'blur'] }
					],
					'expected_receipt_date_start': [
						{ required: true, message: '请选择首款收款日期', trigger: ['change', 'blur'] }
					],
					'expected_receipt_date_end': [
						{ required: true, message: '请选择尾款收款日期', trigger: ['change', 'blur'] }
					],
					'project_need': [
						{ required: true, message: '请填写项目需求说明', trigger: ['change', 'blur'] }
					],
				},
				editForm: {
					'project_type': [
						{ required: true, message: '请选择项目类型', trigger: ['change', 'blur'] }
					],
					'customer_id': [
						{ required: true, message: '请选择客户', trigger: ['change', 'blur'] }
					],
					'medium_id': [
						{ required: true, message: '请选择媒介', trigger: ['change', 'blur'] }
					],
					'is_payment': [
						{ required: true, message: '请选择是否预收款', trigger: ['change', 'blur'] },
						{
							validator: (rule, value, callback) => {
								if ((this.addForm.is_payment == 'YES' && !this.addForm.payment_ratio) || !value) {
									callback(new Error('请填写预收款比例'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'payment_ratio': [
						{ required: true, message: '请填写预付款比例', trigger: ['change', 'blur'] }
					],
					'project_name': [
						{ required: true, message: '请填写项目名称', trigger: ['change', 'blur'] }
					],
					'project_budget_revenue': [
						{ required: true, message: '请填写项目预算收入', trigger: ['change', 'blur'] },
						{ validator: this.validateNumber, trigger: 'blur' }
					],
					'project_budget_cost': [
						{ required: true, message: '请填写项目预算成本', trigger: ['change', 'blur'] },
						{ validator: this.validateNumber, trigger: 'blur' }
					],
					'expected_release_date': [
						{ required: true, message: '请选择预计发布日期', trigger: ['change', 'blur'] }
					],
					'expected_receipt_date_start': [
						{ required: true, message: '请选择首款收款日期', trigger: ['change', 'blur'] }
					],
					'expected_receipt_date_end': [
						{ required: true, message: '请选择尾款收款日期', trigger: ['change', 'blur'] }
					],
					'project_need': [
						{ required: true, message: '请填写项目需求说明', trigger: ['change', 'blur'] }
					],
				},
				editMediumForm: {
					'medium_id': [
						{ required: true, message: '请选择媒介', trigger: ['change', 'blur'] }
					]
				},
				editExecuteForm: {
					'uid': [
						{ required: true, message: '请选择执行', trigger: ['change', 'blur'] }
					],
					'uid_department_id': [
						{ required: true, message: '请选择部门', trigger: ['change', 'blur'] }
					]
				},
				editProResourceForm: {
					'supplier_id': [
						{ required: true, message: '请选择供应商', trigger: ['change'] }
					],
					'release_method': [
						{ required: true, message: '请选择发布方式', trigger: ['change'] }
					],
					'receiving_bank': [
						{ required: true, message: '请选择供收款银行', trigger: ['change'] }
					],
					'invoice_type': [
						{ required: true, message: '请选择发票信息', trigger: ['change'] }
					],
					'is_platform_order': [
						{ required: true, message: '请选择是否平台下单', trigger: ['change',] }
					],
					'strike_price': [
						{ required: true, message: '请填写执行价格', trigger: ['change'] },
						{
							validator: function (rule, value, callback) {
								if(this.editProResourceForm.is_platform_order == 'YES' && value<=0){
									callback(new Error('【平台下单】类型，执行价不能为0'));
								}else{
									const regex = /^\d+(\.\d{1,2})?$/;
									if (!regex.test(value)) {
										callback(new Error('执行价必须为数字(金额仅保留两位小数)'));
									} else {
										callback();
									}
								}
							}.bind(this), trigger: 'change'
						}
					],
					'quotation_price': [
						{ required: true, message: '请填写客户报价', trigger: ['change'] },
						{
							validator: function (rule, value, callback) {
								const regex = /^\d+(\.\d{1,2})?$/;
								if (!regex.test(value)) {
									callback(new Error('报价必须为数字(金额仅保留两位小数)'));
								} else {
									callback();
								}
							}.bind(this), trigger: 'change'
						}
					],
					'point_price': [
						{
							validator: function (rule, value, callback) {
								const regex = /^\d+(\.\d{1,2})?$/;
								if (!regex.test(value)) {
									callback(new Error('返点必须为数字(金额仅保留两位小数)'));
								} else {
									callback();
								}
							}.bind(this), trigger: 'change'
						}
					],
					'release_time': [
						{ required: true, message: '请选择预计发布日期', trigger: ['change'] }
					],
				},
				turnForm: {
					'refund_bank_id': [
						{ required: true, message: '请选择退款方银行账号', trigger: ['change'] }
					],
					'collect_bank_id': [
						{ required: true, message: '请选择收款方银行账号', trigger: ['change'] }
					],
					'prove_attachment': [
						{
							required: true, validator: (rule, value, callback) => {
								if (this.turnForm.prove_attachment.length < 1) {
									callback(new Error('请上传退款凭证'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'refund_price': [
						{
							required: true, validator: (rule, value, callback) => {
								const regex = /^\d+(\.\d{1,2})?$/;
								if (!value) {
									callback(new Error('请填写退款金额'));
								} else if (!regex.test(value)) {
									callback(new Error('退款金额必须为数字(金额仅保留两位小数)'));
								} else if (value && value > Number(this.turnData.use_refund_price)) {
									callback(new Error('退款金额不可大于可退款金额！'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'refund_date': [
						{ required: true, message: '请选择退款日期', trigger: ['change'] }
					],
					'refund_reason': [
						{ required: true, message: '请填写退款原因', trigger: ['blur'] }
					]
				}
			},
			tableData: {
				total: 0,
				pagesize: 15,
				page: 1,
				data: []
			},
			multipleSelection: [],
			proResourceData: [],//执行列表
			projectId: '',//项目id
			checkStatusVisible: true,
			turnData: {
				use_refund_price: ''
			},
		}
	},
	computed: {
		isCheckList: function () {
			var aa = []
			this.proResourceData.forEach(function (item, index) {
				if (item['status'] == 2) {
					aa.push(1)
				}
			})
			if (aa.length != 0) {
				return false
			} else {
				return true
			}
		},
		tableHeight: function () {
			return window.innerHeight - 320;
		},
		tableHeight2: function () {
			return window.innerHeight - 180;
		},
		checkStatus: function () {
			if (this.proResourceData && this.proResourceData.length > 0) {
				let aa = []
				this.proResourceData.forEach(function (item, index) {
					if ([1, 3, 4, 6, 7, 8, 10].indexOf(item.status) != -1) {
						aa.push(1)
					}
				})

				if (aa.length == this.proResourceData.length) {
					return false
				} else {
					return true
				}
			} else {
				return true
			}
		}
	},
	watch: {
		'addForm.project_budget_revenue' (newValue) {
			const numericValue = Number(this.addForm.project_budget_revenue);
			if (numericValue && typeof numericValue === 'number' && !isNaN(numericValue) && this.addForm.project_budget_revenue > 0) {
				this.addFormlv = ((this.addForm.project_budget_revenue - this.addForm.project_budget_cost) / this.addForm.project_budget_revenue * 100).toFixed(2) + '%'
			} else {
				this.addFormlv = '0.00%'
			}
		},
		'addForm.project_budget_cost' (newValue) {
			const numericValue = Number(this.addForm.project_budget_cost);
			if (numericValue && typeof numericValue === 'number' && !isNaN(numericValue) && this.addForm.project_budget_revenue > 0) {
				this.addFormlv = ((this.addForm.project_budget_revenue - this.addForm.project_budget_cost) / this.addForm.project_budget_revenue * 100).toFixed(2) + '%'
			} else {
				this.addFormlv = '0.00%'
			}
		},
		'editForm.project_budget_revenue' (newValue) {
			const numericValue = Number(this.editForm.project_budget_revenue);
			if (numericValue && typeof numericValue === 'number' && !isNaN(numericValue) && this.addForm.project_budget_revenue > 0) {
				this.editFormlv = ((this.editForm.project_budget_revenue - this.editForm.project_budget_cost) / this.editForm.project_budget_revenue * 100).toFixed(2) + '%'
			} else {
				this.editFormlv = '0.00%'
			}
		},
		'editForm.project_budget_cost' (newValue) {
			const numericValue = Number(this.editForm.project_budget_cost);
			if (numericValue && typeof numericValue === 'number' && !isNaN(numericValue) && this.addForm.project_budget_revenue > 0) {
				this.editFormlv = ((this.editForm.project_budget_revenue - this.editForm.project_budget_cost) / this.editForm.project_budget_revenue * 100).toFixed(2) + '%'
			} else {
				this.editFormlv = '0.00%'
			}
		}
	},
	mounted: function () {
		//this.handleSearch(this.searchForm)
		this.getUserSelect('', '')
		this.getDepartmentOption()
	},
	methods: {
		canelproject(row,index){
			this.$confirm('此操作将【作废】该项目, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.post('/admin/customers/customer/canelproject', { id:row.id}).then(res => {
						if(res.code == 0){
							this.$set(this.tableData.data[index],'status',13)
							this.$set(this.tableData.data[index],'status_txt','已作废')
							this.$message.success('修改成功');
						}else{
							this.$message.error(res.msg);
						}
					})
        });
		},
		editProjectName (row, index) {
			this.$api.get('/admin/customers/customer/getproject', { project_code: row.project_code }).then(res => {
				if (res.code === 0) {
					this.$prompt('谨慎修改新的项目名称', '修改', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						inputValue:res.data.project_name,
						inputValidator:(value)=>{
							if (!value || value.trim() === '') {
									return '项目名称不能为空！';
							}
							return true;
						},
						inputErrorMessage: '请输入新的项目名称'
					}).then(({ value }) => {
						this.$api.post('/admin/customers/customer/editprojectname', { project_code:row.project_code,project_name:value}).then(res => {
							if(res.code == 0){
								
								this.$set(this.tableData.data[index],'project_name',value)
								this.$message.success('修改成功');
							}else{
								this.$message.error(res.msg);
							}
						})
					})
				}
			})
		},
		getDepartmentOption () {
			this.$api.get('/admin/users/user/getDepartmentTree').then(res => {
				if (res.code === 0) {
					this.options.dept_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		getUserSelect (query, type) {
			query = query ? query : '';
			this.$api.post('/admin/users/user/getuserbydepartment', { query: query }).then(res => {
				if (res.code === 0) {
					if (type == 'meijie') {
						this.options.edit_medium_id_options = res.data;
					} else if (type == 'kehu') {
						this.options.uid_options = res.data;
					} else if (type == 'shangwu') {
						this.options.business_docking_id_options = res.data;
					} else {
						this.options.edit_medium_id_options = res.data;
						this.options.business_docking_id_options = res.data;
						this.options.uid_options = res.data;
					}
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		filterPaystatus (value, row) {
			return row.payment_status == value;
		},
		changePoint (val) {
			if (val == 'NO') {
				this.editProResourceForm.point_price = 0
				this.bypricetonum()
			}
		},
		filterStatus (value, row) {
			return row.status == value;
		},
		tableRowClassName ({ row }) {
			if (row.li_run_lv.includes('-') || row.li_run.includes('-')) {
				return 'negative-row';
			}
			return '';
		},
		viewJianYiPrice (value) {
			this.options.release_method_options.forEach(function (item, index) {
				if (item.value == value) {
					this.janyi_p_price = Number(item.p_price)
					this.janyi_f_price = Number(item.u_price)
					this.janyi_z_price = Number(item.r_price)
					this.janyi_h_price = Number(item.h_price)

					this.janyi_point_p_price = Number(item.p_point)
					this.janyi_point_f_price = Number(item.u_point)
					this.janyi_point_z_price = Number(item.r_point)
					this.janyi_point_h_price = Number(item.h_point)
				}
			}.bind(this))
		},
		isColor (text) {
			if (text.includes('上升')) {
				return '#67C23A'
			} else if (text.includes('下降')) {
				return '#F56C6C'
			} else {
				return '#606266'
			}
		},
		isUp (val) {
			if (val.includes('上升')) {
				return val.replace("上升", "↑")
			} else if (val.includes('下降')) {
				return val.replace("下降", "↓")
			} else {
				return val
			}
		},
		closeCase (type) {
			var txt = ''
			if (type == 1) {
				txt = '结案'
			} else {
				txt = '反结案'
			}
			this.$prompt('请输入' + txt + '备注', txt, {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputValidator: (value) => {
					if (!value) {
						return '请输入' + txt + '备注,必填项'
					} else {
						if (value.length > 100) {
							return '备注不能超过100个字符'
						} else {
							return true
						}
					}
				},
				inputErrorMessage: ''
			}).then(({ value }) => {
				this.$api.post('/admin/customers/customer/solveprojectorun', { 'project_id': this.multipleSelection[0]['id'], 'remark': value, 'type': type }).then(res => {
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: txt + '申请提交成功!可在【其他】--【结案/反结案】模块查看详情'
						});
						this.$refs.table.clearSelection();
						this.handleSearch(this.searchForm)
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						});
					}
				})
			}).catch(() => { });
		},
		exportData () {
			this.isDownloading = true;
			var excelSearch = JSON.parse(JSON.stringify(this.searchForm))
			excelSearch.downloadType = 'project'
			this.$api.get('/admin/customers/export/exportprojectexcel', excelSearch).then(res => {
				if (res.code == 0) {
					this.$alert('异步下载任务【项目列表下载】创建成功！请稍后查看下载列表', '下载提示', {
						confirmButtonText: '确定',
					});
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					});
				}
				this.isDownloading = false;
				// // 将Blob转换为URL以便创建一个可下载的链接
				// const url = window.URL.createObjectURL(new Blob([res]));
				// const link = document.createElement('a');
				// link.href = url;
				// link.setAttribute('download', '项目相关信息表.xlsx'); // 设置下载文件名
				// document.body.appendChild(link);
				// link.click(); // 触发点击下载
				// document.body.removeChild(link); // 下载后移除元素
				// window.URL.revokeObjectURL(url); // 释放URL对象
				// this.isDownloading = false
				// this.$alert('您所下载的Excel数据已完毕,请查收！', '下载提示', {
				// 	confirmButtonText: '确定',
				// });
			})
		},
		handleTableDelete (row) {
			this.$confirm('此操作将永久删除该项目及项目相关执行, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.delete('/admin/customers/customer/delprojects', { project_id: row.id }).then(res => {
					if (res.code === 0) {
						var data = this.tableData.data;
						data.forEach(function (item, index) {
							if (item.project_code == row.project_code) {
								this.$delete(data, index);
							} else if (item.children) {
								item.children.forEach(function (value, key) {
									if (value.project_code == row.project_code) {
										this.$delete(item.children, key);
									}
								}.bind(this));
							}
						}.bind(this));
						this.$message({
							showClose: true,
							message: '该项目已成功删除！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		validateNumber (rule, value, callback) {
			const regex = /^\d+(\.\d{1,2})?$/; // 匹配整数或小数
			if (!regex.test(value)) {
				return callback(new Error('请输入数字(金额仅保留两位小数)'));
			} else {
				callback();
			}
		},
		//列表
		handleSearch (params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/customers/customer/getprojectlist', param).then(res => {
				if (res.code == 0) {
					this.tableData = res.data;
					this.$nextTick(() => {
						if (this.$refs.table) {
							this.$refs.table.doLayout();
						}
					});
					this.getCustomer()//获取客户
					this.getUserTree()//获取所有用户
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false;
			})
		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset () {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			} else {
				prop = this.resetSearch.prop;
				order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},
		//创建弹窗
		addProjectOpen () {
			this.addForm = {
				project_type: "",
				customer_id: "",
				medium_id: '',
				is_payment: "NO",
				payment_ratio: '',
				project_name: "",
				project_budget_revenue: "",
				project_budget_cost: "",
				expected_release_date: "",
				expected_receipt_date_start: "",
				expected_receipt_date_end: "",
				project_need: "",
				project_need_imgs: []
			}
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
			this.medium_department_id = ''
			this.addFormVisiable = true
		},
		//创建项目
		addProject () {
			const d1 = new Date(this.addForm.expected_receipt_date_start);
			const d2 = new Date(this.addForm.expected_receipt_date_end);
			if (d1.getTime() > d2.getTime()) {
				this.$message.error('预计尾款收款日期不得早于预计首款收款日期');
				return
			}
			const formData = new FormData()
			for (const key in this.addForm) {
				if (key == 'project_need_imgs') {
					if (this.addForm[key].length > 0) {
						this.addForm[key].forEach(item => {
							formData.append(key, item)
						})
					} else {
						formData.append(key, '')
					}
				} else {
					formData.append(key, this.addForm[key]);
				}
			}
			this.$refs['addForm'].validate(function (valid) {
				if (valid) {
					this.loading = true;
					this.$api.post('/admin/customers/customer/createproject', formData).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch();
							this.$message({
								showClose: true,
								message: '项目创建成功！',
								type: 'success'
							});
							this.addFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				}
			}.bind(this));
		},
		//编辑弹窗
		handleTableEditOpen (row) {
			this.loading = true
			this.$api.get('/admin/customers/customer/getproject', { project_code: row.project_code }).then(res => {
				if (res.code === 0) {
					this.editForm = res.data
					this.editForm.status = row.status
					this.editForm.customer_name = row.customer_name
					this.editFormVisiable = true;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//编辑项目
		editProject () {
			const d1 = new Date(this.editForm.expected_receipt_date_start);
			const d2 = new Date(this.editForm.expected_receipt_date_end);
			if (d1.getTime() > d2.getTime()) {
				this.$message.error('预计尾款收款日期不得早于预计首款收款日期');
				return
			}
			const formData = new FormData()
			for (const key in this.editForm) {
				if (key == 'project_need_imgs') {
					if (this.editForm[key].length > 0) {
						this.editForm[key].forEach(item => {
							if (!item.type) {
								formData.append(key, JSON.stringify(item))
							} else {
								formData.append(key, item)
							}

						})
					} else {
						formData.append(key, '')
					}
				} else {
					formData.append(key, this.editForm[key]);
				}
			}
			this.$refs['editForm'].validate(function (valid) {
				if (valid) {
					this.loading = true;
					this.$api.post('/admin/customers/customer/editproject', formData).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch('', this.tableData.page);
							this.$message({
								showClose: true,
								message: '项目信息修改成功！',
								type: 'success'
							});
							this.editFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				}
			}.bind(this));
		},
		//获取客户
		getCustomer (query) {
			query = query || '';
			this.$api.get('/admin/customers/customer/getcustomerselect', { 'query': query }).then(res => {
				if (res.code === 0) {
					this.options.customer_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		onSelectAll () {
			this.$refs.table.clearSelection();
		},
		selectItem (rows) {
			if (rows.length > 0) {
				const newRows = rows.filter((it, index) => {
					// if (index == rows.length - 1) {
					if (it.status!=13) {
						this.$refs.table.toggleRowSelection(it, true);
						return true;
					} else {
						this.$refs.table.toggleRowSelection(it, false);
						this.$message.error('禁止选择已作废的项目数据');
						return false;
					}
				});
				this.multipleSelection = newRows;
			} else {
				this.multipleSelection = rows;
			}
			this.userId = this.multipleSelection.length
				? this.multipleSelection[0].guid
				: "";
		},
		onSelectOp (row) {
			this.multipleSelection = []
			if (row.status!=13) {
					this.$refs.table.toggleRowSelection(row, true);
					this.multipleSelection.push(row)
			}else{
				this.$refs.table.toggleRowSelection(row, false);
				this.$message.error('【已作废】的项目不可勾选');
			}
		},
		//重新分配媒介弹窗打开
		editMediumOpen () {
			if (this.multipleSelection.length > 0) {
				if (this.multipleSelection[0].status == 11) {
					this.$message.error('变更中，不能重复操作！');
					return
				}
				this.medium_department_id = ''
				this.editMediumFormVisiable = true
				this.$api.get('/admin/customers/customer/getproject', { project_code: this.multipleSelection[0].project_code }).then(res => {
					if (res.code === 0) {
						this.editMediumForm.medium_id = res.data.edit_medium_id
						this.medium_department_id = res.data.medium_department_id
						this.editMediumForm.project_code = res.data.project_code
						this.handleChangeDepartmentFrist(res.data.medium_department_id)
					}
				})
			} else {

				this.$message.error('请选择操作项');
			}
		},
		//重新分配媒介
		editMedium () {
			this.loading = true
			this.$api.put('/admin/customers/customer/editmedium', this.editMediumForm).then(res => {
				if (res.code === 0) {
					this.$message({
						showClose: true,
						message: '该项目已成功分配媒介！',
						type: 'success'
					});
					this.editMediumFormVisiable = false
					this.handleSearch(this.searchForm)
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		handleChangeDepartmentFrist (value) {
			this.$api.post('/admin/users/user/getuserbydepartment', { department_id: [value] }).then(res => {
				if (res.code === 0) {
					this.options.users_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		handleChangeDepartment (value) {
			this.options.users_options = []
			this.addForm.medium_id = ''
			this.editMediumForm.medium_id = ''
			this.$api.post('/admin/users/user/getuserbydepartment', { department_id: [value] }).then(res => {
				if (res.code === 0) {
					this.options.users_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//获取所有用户
		getUserTree () {
			this.options.usertree_options = []
			this.$api.get('/admin/users/user/getDepartmentTree').then(res => {
				if (res.code === 0) {
					this.options.usertree_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//接受任务
		acceptProject () {
			if (this.multipleSelection.length > 0) {
				if ([5, 11].indexOf(this.multipleSelection[0].status) == -1) {
					this.$message.error('已有媒介领取任务，不能重复领取！');
				} else {
					this.$confirm('是否接受该任务', '接受任务', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(function () {
						this.$api.post('/admin/customers/customer/acceptproject', { project_code: this.multipleSelection[0].project_code }).then(res => {
							if (res.code === 0) {
								this.handleSearch(this.searchForm)
								// var data = this.tableData.data;
								// data.forEach(function (item, index) {
								// 	if (this.multipleSelection[0].project_code == item.project_code) {
								// 		this.$set(data[index], 'status_txt', res.data.status_txt);
								// 		this.$set(data[index], 'status', res.data.status);
								// 	}
								// }.bind(this));
								this.$refs.table.clearSelection();
								this.$message({
									showClose: true,
									message: res.msg,
									type: 'success'
								});
							} else {
								this.$message.error(res.msg);
							}
							this.loading = false
						})
					}.bind(this))
				}
			} else {
				this.$message.error('请选择操作项');
			}
		},
		//提交审批
		handleTableFlow (row) {
			this.loading = true
			this.$api.post('/admin/customers/customer/submitprojectapproval', { project_id: row.id }).then(res => {
				if (res.code === 0) {
					var data = this.tableData.data;
					data.forEach(function (item, index) {
						if (row.id == item.id) {
							this.$set(data[index], 'status_txt', '待审核');
							this.$set(data[index], 'status', 2);
						}
					}.bind(this));
					this.$message({
						showClose: true,
						message: '该项目已进入审批流程，等待审核！',
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//点击查看大图
		viewImg (file) {
			if (!file.path) {
				//还未上传
				let url = URL.createObjectURL(file)
				if (file.name.includes('.jpg') || file.name.includes('.jpeg') || file.name.includes('.png')) {
					this.dialogImageUrl = url;
					this.dialogVisibleImg = true;
				} else {
					window.open(url)
				}
			} else {
				//已上传
				if (file.name.includes('.jpg') || file.name.includes('.jpeg') || file.name.includes('.png')) {
					this.dialogImageUrl = file.path;
					this.dialogVisibleImg = true;
				} else {
					window.open(file.path)
				}
			}
		},
		//上传图片
		changeRequired (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this[formobj][field] = [file.raw]
			} else {
				this[formobj][field].push(file.raw)
			}
		},
		//移除图片
		handleRemoveUpload (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this[formobj][field] = []
			} else {
				this[formobj][field].forEach(function (item, index) {
					if (item.name == file.name) {
						this.$delete(this[formobj][field], index)
					}
				}.bind(this))
			}

		},
		//打开详情页
		detail (row) {
			this.$router.push({
				name: 'ProjectDetail',
				query: { id: row.id, set_id: 5, type: 'detail' }
			});
		},
		handleTableResourceOpen (row) {
			this.$router.push({
				name: 'ResourceCart',
				query: { project_code: row.project_code, project_name: row.project_name }
			});
		},
		//匹配补充弹窗打开
		handleTableProResourceOpen (row, type) {
			if (type == 'baojia') {
				this.checkStatusVisible = false
				this.editProResourcelistVisiableTitle = '报价'
			} else {
				this.checkStatusVisible = true
				this.editProResourcelistVisiableTitle = '匹配补充'
			}
			this.getProResource(row.id)
			this.projectId = row.id
			this.editProResourcelistVisiable = true
		},
		//获取执行列表
		getProResource (id) {
			this.loading = true
			this.$api.get('/admin/customers/customer/getbyprojectcodetoexcute', { id: id }).then(res => {
				if (res.code === 0) {
					this.proResourceData = res.data
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//补充详情弹窗打开
		proResourceDetailOpen (row) {

			this.getProResourceDetail(row, (res) => {
				this.pipeibucho = row.id
				this.editProResourceFormVisiable = true
			})
		},
		//获取执行详情
		getProResourceDetail (row, fun) {
			this.loading = true
			this.$api.get('/admin/customers/customer/getproresource', { execute_code: row.execute_code }).then(res => {
				if (res.code === 0) {
					res.data['is_xiaohongxing'] = 'NO'
					this.$set(this,'editProResourceForm',res.data)
					if (this.editProResourceForm.supplier_id) {
						this.getSupplierOptions(row)
						this.changSupplier()
					}
					fun()
					this.$nextTick(() => {
						this.$refs['editProResourceForm'].clearValidate();
					});

				} else {
					this.$message.error(res.msg);
				}
				this.loading = false

			})
		},
		//获取供应商下拉列表
		getSupplierOptions (row) {
			this.editProResourceForm.resource_id = row.resource_id
			this.$api.get('/admin/resources/resources/supldwn', { rsid: row.resource_id, is_default: this.editProResourceForm.platform_id == 9 ? 'no' : 'yes' }).then(res => {
				if (res.code === 0) {
					// 服务号
					if (this.editProResourceForm.platform_id == 9) {
						this.options.supplier_id_options = res.data
					} else {
						res.data.forEach(function (item, index) {
							if (item.value == this.editProResourceForm.supplier_id) {
								this.supplier_name = item['label']
							}
						}.bind(this))
					}
				}
			})
		},
		//选中供应商
		changSupplier () {
			this.getReleaseMethodOptions()
			this.getReceivingBankOptions()
			this.getInvoiceTypeOptions()
		},
		//获取发布方式下拉列表
		getReleaseMethodOptions () {

			this.$api.get('/admin/resources/resources/rspdwlist', { rsid: this.editProResourceForm.resource_id, sid: this.editProResourceForm.supplier_id, execute_code: this.editProResourceForm.execute_code }).then(res => {
				if (res.code === 0) {
					this.options.release_method_options = res.data

					if (this.editProResourceForm.release_method) {
						this.viewJianYiPrice(this.editProResourceForm.release_method)
					}
				}
			})
		},
		changexiaohx(val){
			this.editProResourceForm.strike_price = ''
			this.editProResourceForm.zhichu_price = ''
		},
		changeBank (val) {
			if(val=='NO'){
				this.editProResourceForm.is_xiaohongxing = 'NO'
			}
			this.editProResourceForm.receiving_bank = ''
			this.editProResourceForm.invoice_type = ''
			this.editProResourceForm.strike_price = ''
			this.editProResourceForm.zhichu_price = ''
			this.getReceivingBankOptions()
		},
		//获取收款银行下拉列表
		getReceivingBankOptions () {

			if (this.editProResourceForm.is_platform_order == 'YES') {
				var id = this.editProResourceForm.resource_id
				var relevance = 3
			} else {
				var id = this.editProResourceForm.supplier_id
				var relevance = 1
			}
			this.$api.get('/admin/resources/resources/supbankdw', { sid: id, relevance: relevance, is_platform_order: this.editProResourceForm.is_platform_order }).then(res => {
				if (res.code === 0) {
					this.options.receiving_bank_options = res.data
				}
			})
		},
		changeInvoice () {
			this.getInvoiceTypeOptions()
		},
		//获取发票信息下拉列表
		getInvoiceTypeOptions () {
			if (this.editProResourceForm.is_platform_order == 'YES') {
				var id = this.editProResourceForm.resource_id
				var relevance = 3
				var is_platform_view = 'resource_id'
			} else {
				var id = this.editProResourceForm.supplier_id
				var relevance = 1
				var is_platform_view = 'supplier_id'
			}
			this.$api.get('/admin/resources/resources/supinvoicedw', { sid: id, relevance: relevance, is_platform_view: is_platform_view }).then(res => {
				if (res.code === 0) {
					this.options.invoice_type_options = res.data
				}
			})
		},
		//实时获取计算后的价格
		bypricetonum (type) {
			const regex = /^\d+(\.\d{1,2})?$/;
			if (this.editProResourceForm.strike_price && !regex.test(this.editProResourceForm.strike_price)) {
				return
			}
			if (this.editProResourceForm.quotation_price && !regex.test(this.editProResourceForm.quotation_price)) {
				return
			}
			if (this.editProResourceForm.point_price && !regex.test(this.editProResourceForm.point_price)) {
				return
			}
			let params = {
				execute_id: this.pipeibucho,
				release_method: this.editProResourceForm.release_method,
				is_platform_order: this.editProResourceForm.is_platform_order,
				supplier_id: this.editProResourceForm.supplier_id,
				strike_price: this.editProResourceForm.strike_price,
				quotation_price: this.editProResourceForm.quotation_price,
				point_price: this.editProResourceForm.point_price,
				invoice_type: this.editProResourceForm.invoice_type,
				is_xiaohongxing: this.editProResourceForm.is_xiaohongxing,
				is_baojia:type ? type : ''
			}

			this.loading = true
			this.$api.get('/admin/customers/customer/bypricetonum', params).then(res => {
				if (res.code === 0) {
					Object.assign(this.editProResourceForm, res.data);
					this.loading = false
				}
			})
		},
		//匹配补充
		editProResource () {
			this.$refs['editProResourceForm'].validate((valid) => {
				if (valid) {
					this.loading = true
					this.$api.post('/admin/customers/customer/editproresource', this.editProResourceForm).then(res => {
						if (res.code === 0) {
							this.getProResource(this.projectId)//刷新匹配补充列表
							this.editProResourceFormVisiable = false
							this.$message({
								showClose: true,
								message: res.msg ? res.msg : '操作成功！',
								type: 'success'
							});
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				}
			})

		},
		//报价弹窗打开
		executeQuotationOpen (row) {
			this.getProResourceDetail(row, () => {
				this.pipeibucho = row.id
				this.executeQuotationFormVisiable = true
			})

		},
		//提交报价
		executeQuotation () {
			this.loading = true
			// this.$api.post('/admin/customers/customer/executequotation',{'execute_code':this.editProResourceForm.execute_code,'quotation_price':this.editProResourceForm.quotation_price,'release_time':this.editProResourceForm.release_time}).then(res => {
			this.$api.post('/admin/customers/customer/executequotation', { 'execute_code': this.editProResourceForm.execute_code, 'quotation_price': this.editProResourceForm.quotation_price, 'release_time': this.editProResourceForm.release_time }).then(res => {
				if (res.code === 0) {
					this.getProResource(this.projectId)//刷新匹配补充列表
					this.executeQuotationFormVisiable = false
					this.$message({
						showClose: true,
						message: res.msg,
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//删除执行记录
		delProresource (row) {
			this.$confirm('该条执行为客户指定执行，确认删除吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.delete('/admin/customers/customer/delproresource', { execute_code: row.execute_code }).then(res => {
					if (res.code === 0) {
						var data = this.proResourceData;
						data.forEach(function (item, index) {
							if (item.execute_code == row.execute_code) {
								this.$delete(data, index);
							}
						}.bind(this));
						this.$message({
							showClose: true,
							message: '该资源已成功删除！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		//复制执行
		copyProResource (row) {
			this.$confirm('确定复制该条执行信息吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.$api.post('/admin/customers/customer/copyproresource', { execute_code: row.execute_code }).then(res => {
					if (res.code === 0) {
						this.proResourceData.unshift(res.data)
					}
				})
			}.bind(this))
		},
		//提交匹配
		submitproresource () {
			this.loading = true
			this.$api.post('/admin/customers/customer/submitproresource', { project_id: this.projectId }).then(res => {
				if (res.code === 0) {
					var data = this.tableData.data;
					data.forEach(function (item, index) {
						if (this.projectId == item.id) {
							this.$set(data[index], 'status_txt', '待提交');
							this.$set(data[index], 'status', 1);
						}
					}.bind(this));
					this.editProResourcelistVisiable = false
					this.$message({
						showClose: true,
						message: '资源匹配成功！',
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//重新分配执行弹窗打开
		editExecuteOpen () {
			if (this.multipleSelection.length > 0) {
				this.editExecuteForm.uid_department_id = ''
				this.editExecuteForm.uid = ''
				this.editExecuteFormVisiable = true
				this.loading = true
				this.$api.get('/admin/customers/customer/getproject', { project_code: this.multipleSelection[0].project_code }).then(res => {
					if (res.code === 0) {
						this.editExecuteForm.uid_department_id = res.data.uid_department_id
						this.editExecuteForm.uid = res.data.uid
						this.editExecuteForm.project_code = res.data.project_code
						this.loading = false
						this.$refs.table.clearSelection();
						this.handleChangeDepartmentFrist(res.data.uid_department_id)
					}
				})
			} else {
				this.$message.error('请选择操作项');
			}
		},
		//重新分配执行
		editExecute () {
			this.loading = true
			this.$api.post('/admin/customers/customer/editcustomerabutment', this.editExecuteForm).then(res => {
				if (res.code === 0) {
					this.$message({
						showClose: true,
						message: '该项目已成功分配执行！',
						type: 'success'
					});
					this.editExecuteFormVisiable = false
					this.handleSearch(this.searchForm)
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//打开退款申请弹窗
		openTurn () {
			this.turnForm = {
				project_ids: this.multipleSelection[0]['id'],
				refund_bank_id: '',
				collect_bank_id: '',
				prove_attachment: [],
				refund_date: '',
				refund_price: '',
				refund_reason: '',
				remark: ''
			}
			this.options.refund_bank_id_options = []
			this.options.collect_bank_id_options = []
			this.turnData.use_refund_price = ''
			this.$nextTick(() => {
				this.$refs['turnForm'].clearValidate();
			});
			this.loading = true
			this.turnFormVisiable = true
			this.$api.get('/admin/customers/customer/refundbankcardlist', { refund_type: 3 }).then(res => {
				if (res.code === 0) {
					this.options.refund_bank_id_options = res.data
				}
			})
			this.$api.get('/admin/customers/customer/collectbankcardlist', { project_id: this.multipleSelection[0]['id'], refund_type: 3 }).then(res => {
				if (res.code === 0) {
					this.options.collect_bank_id_options = res.data
				}
			})
			this.$api.get('/admin/customers/customer/projectinforefundprice', { project_id: this.multipleSelection[0]['id'], refund_type: 3 }).then(res => {
				if (res.code === 0) {
					this.turnData = res.data
					this.turnForm.type = res.data.refund_type
					this.$set(this.turnForm, 'refund_price', '')

				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		addTurn () {
			const formData = new FormData()
			for (const key in this.turnForm) {
				if (key == 'prove_attachment') {
					if (this.turnForm[key].length > 0) {
						this.turnForm[key].forEach(item => {
							formData.append(key, item)
						})
					} else {
						formData.append(key, '')
					}
				} else {
					formData.append(key, this.turnForm[key]);
				}
			}
			this.$refs['turnForm'].validate(function (valid) {
				if (valid) {
					this.loading = true;
					this.$api.post('/admin/customers/customer/createsubmitrefundRequest', formData).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch();
							this.$message({
								showClose: true,
								message: '退款申请创建成功！',
								type: 'success'
							});
							this.turnFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				}
			}.bind(this));
		},
	},

	beforeRouteEnter (to, from, next) {
		next(vm => {
			const hasQuery = Object.keys(to.query).length > 0;
			if (from.path !== '/projectDetail' && !hasQuery) {
				vm.reset();
			} else if (hasQuery) {
				// 有传参的时候重新发起带条件的传参
				let query_data = to.query
				vm.searchForm.project_code = query_data['project_code']
				vm.handleSearch(vm.searchForm)
			}
		});
	}
}
</script>
<style lang="scss" scoped>
.select {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;

	.form {
		padding-top: 100px;
		width: 500px;
	}
}

.resource_name {
	.el-form-item__content {
		display: flex;
		align-items: center;

		img {
			width: 14px;
			height: 14px;
			margin-right: 4px;
		}

		span {
			color: #409EFF;
		}
	}
}
</style>